<template>
  <div>
    <top-nav v-if="!hideTopNav" />
    <side-bar v-if="!hideSideBar" />
    <slot />
  </div>
</template>

<script>

import SideBar from '../components/SideBar.vue'
import TopNav from '../components/TopNav.vue'

export default {
  name: 'Layout',
  components: {
    SideBar,
    TopNav,
  },
  props: {
    hideSideBar: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideTopNav: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
